module.exports = __webpack_public_path__ + "static/media/pic2.2864c56c.png";